exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul.links{margin:0;padding:0}ul.links li{list-style-type:none;text-align:center}ul.links li a{color:#454545;-webkit-transition:all .5s ease;transition:all .5s ease}ul.links li a:hover{color:#ff4961}", ""]);

